import { matchRoute } from "@softmax/web-addresses";

export function isStartRoom(pathname: string | null): boolean {
  return pathname !== null && matchRoute(pathname).name === "game.start";
}
